<template>
  <div>
    <div>
      <v-toolbar elevation="0">
        <v-toolbar-title>{{selectedchat.userb.member.membername}}</v-toolbar-title>
        <v-avatar>
          <v-img height="150"  width="50" src="../../assets/typing.gif"></v-img>
        </v-avatar>
        <v-spacer/>
        <v-btn @click="ambilpesan" text icon>
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
        <v-toolbar-items>
        </v-toolbar-items>
      </v-toolbar>
    </div>
    <div>
      <div class="chat-container" v-on:scroll="onScroll" ref="chatContainer">
        <MessageItem :messages="messages"/>
      </div>
      <v-text-field outlined v-model="textmsg" @keypress="sendingmsg" dense clearable class="mr-2 ml-2 pt-2" placeholder="Ketik pesan..."></v-text-field>
    </div>
  </div>
</template>

<script>
import MessageItem from '@/components/chat/MessageItem'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'ChatCompose',
  components: { MessageItem },
  data: () => ({
    textmsg: '',
    content: '',
    chatMessages: [],
    emojiPanel: false,
    currentRef: {},
    loading: false,
    totalChatHeight: 0,
    token: localStorage.getItem('token'),
    user: localStorage.getItem('user')
  }),
  mounted () {
    console.log(JSON.parse(this.user).id)
  },
  watch: {
    messages: function (s) {
      this.scrollToEnd()
    }
  },
  computed: {
    ...mapState('ChatStore', ['selectedgroupid', 'messages', 'selectedchat'])
  },
  methods: {
    ...mapActions('ChatStore', ['getMessages', 'sendMessage']),
    ambilpesan () {
      console.log('getmessages')
      this.getMessages(this.selectedgroupid)
    },
    onScroll () {
    },
    scrollToEnd () {
      this.$nextTick(() => {
        var container = this.$el.querySelector('.chat-container')
        container.scrollTop = container.scrollHeight
      })
    },
    sendingmsg (e) {
      console.log(e)
      if (e.code === 'Enter') {
        const newmsg = {
          groupid: this.selectedchat.groupid,
          to: this.selectedchat.untukuser,
          image: '',
          msg: this.textmsg
        }
        this.$socket.emit('notifmsg', newmsg)
        this.sendMessage(newmsg)
        this.textmsg = ''
        this.scrollToEnd()
      }
    }
  }
}
</script>

<style scoped>
.chat-container{
  box-sizing: border-box;
  height: calc(86vh - 9.5rem);
  overflow-y: auto;
  padding: 10px;
  background-color: #f2f2f2;
}
.scrollable {
  overflow-y: auto;
  height: 90vh;
}
.typer{
  box-sizing: border-box;
  display: flex;
  align-items: center;
  bottom: 0;
  height: 4.9rem;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 -5px 10px -5px rgba(0,0,0,.2);
}
.typer input[type=text]{
  position: absolute;
  left: 2.5rem;
  padding: 1rem;
  width: 80%;
  background-color: transparent;
  border: none;
  outline: none;
  font-size: 1.25rem;
}
.message{
  margin-bottom: 3px;
}
.message.own{
  text-align: right;
}
.message.own .content{
  background-color: lightskyblue;
}
.chat-container .username{
  font-size: 18px;
  font-weight: bold;
}
.chat-container .content{
  padding: 8px;
  background-color: lightgreen;
  border-radius: 10px;
  display:inline-block;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.2), 0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12);
  max-width: 50%;
  word-wrap: break-word;
}
@media (max-width: 480px) {
  .chat-container .content{
    max-width: 60%;
  }
}
</style>
